import hugerte from 'hugerte'
import 'hugerte/models/dom'
import 'hugerte/icons/default'
import 'hugerte/themes/silver'
import 'hugerte/skins/ui/oxide/skin.js'
import 'hugerte/skins/ui/oxide/content.js'
import 'hugerte/skins/content/default/content.js'
import 'hugerte/plugins/emoticons'
import 'hugerte/plugins/emoticons/js/emojis'
import 'hugerte/plugins/autoresize'
import 'hugerte/plugins/lists'
import 'hugerte/plugins/autolink'
import 'hugerte/plugins/link'

import { ref } from 'vue'

export const hugeRteSkinDefaults = Object.freeze({
    skin_url: 'default',
    content_css: 'default'
})

export function getEditorInit(overrides = {}) {
    return {
        ...hugeRteSkinDefaults,
        ...overrides
    }
}

function ensureGlobal() {
    globalThis.hugerte = hugerte
    if (typeof window !== 'undefined') {
        window.hugerte = hugerte
        window.hugeRTE = hugerte
    }
}

function patchInitDefaults() {
    if (hugerte.__kbSkinDefaultsPatched) {
        return
    }
    const originalInit = hugerte.init.bind(hugerte)
    hugerte.init = (settings = {}) =>
        originalInit({
            ...hugeRteSkinDefaults,
            ...settings
        })
    hugerte.__kbSkinDefaultsPatched = true
}

ensureGlobal()
patchInitDefaults()

export function loadHugeRTE() {
    if (!globalThis.hugerte?.init) {
        return Promise.reject(new Error('HugeRTE global missing after bootstrap'))
    }
    return Promise.resolve(hugerte)
}

// Sync bootstrap above → ready on first render (no onMounted gate).
export function useHugeRTE() {
    const editorReady = ref(true)

    const ensureEditor = () => loadHugeRTE()

    return {
        editorReady,
        ensureEditor
    }
}
